module.exports = __webpack_public_path__ + "static/media/MacPortrait2w990@1x.c902c719.webp";